export const formatPrice = (value: number | string): string => {
  if (value === undefined || value === null) return '';
  const floatValue = typeof value === 'string' ? parseFloat(value) : value;
  return floatValue.toLocaleString('de-DE', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};
